import { useContext } from "react";
import AuthContext from "../../components/auth-context";
import Button from "../../components/tailwind/button";
import AppLink from "../../components/router/app-link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RegisterTicketApi from "../../api/register-ticket";
import SGrid from "../../components/sgrid";

function Tickets() {
  const context = useContext(AuthContext);
  const { activeFileId } = context;
  const dataProvider = (page: number, pageSize: number) =>
    new RegisterTicketApi(context).get(activeFileId!, page, pageSize);

  return (
    <>
      <Button
        className="btn bgc-white btn-light-secondary mx-0"
        dataToggle="tooltip"
      >
        <AppLink to="/registerTicket">
          <FontAwesomeIcon icon="plus-circle" className="text-green" />
          <small className="ml-2">افزودن تیکت جدید</small>
        </AppLink>
      </Button>
      <div className="card dcard overflow-x-scroll" style={{ padding: "5px" }}>
        <SGrid
          dataProvider={dataProvider}
          columns={[
            "",
            ["تاریخ", "date", 1],
            ["موضوع", "farsi", 2],
            ["توضیحات", "description", 3],
          ]}
        />
      </div>
    </>
  );
}

export default Tickets;
